'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { useAuthStore } from '../stores';

export function StoreProvider({ children }: { children: React.ReactNode }) {
  const { user, isLoaded } = useUser();
  const setUser = useAuthStore((state) => state.setUser);

  useEffect(() => {
    if (!isLoaded) {
      // Keep isLoading true while user data loads
      return;
    }

    if (user) {
      // Fetch tier from database metadata
      fetch('/api/user/settings')
        .then((res) => res.json())
        .then((data) => {
          setUser({
            id: user.id,
            email: user.primaryEmailAddress?.emailAddress || '',
            name: user.fullName || user.username || 'User',
            avatar: user.imageUrl,
            tier: data.tier || 'FREE',
            role: (user.publicMetadata?.role as 'USER' | 'ADMIN') || 'USER',
          });
        })
        .catch(() => {
          // Fallback if API fails
          setUser({
            id: user.id,
            email: user.primaryEmailAddress?.emailAddress || '',
            name: user.fullName || user.username || 'User',
            avatar: user.imageUrl,
            tier: 'FREE',
            role: 'USER',
          });
        });
    } else {
      // User is not authenticated
      setUser(null);
    }
  }, [user, isLoaded, setUser]);

  return <>{children}</>;
}
